import styled from 'styled-components';
import { marginStyles } from '../../styles/components.js';

const Fieldset = styled.fieldset `
  ${props => marginStyles(props.margin)}
  border: 0;
  padding: 0.01em 0 0 0;
  min-width: 0;
  width: ${props => props.width};

  && body:not(:-moz-handler-blocked) {
    display: table-cell;
  }
`;
styled.legend `
  padding: 0;
  display: table;
`;
const Container = styled.div `
  width: ${props => props.width};
  ${props => marginStyles(props.margin)};
`;

export { Container, Fieldset };
